import { render, staticRenderFns } from "./CommonModel.vue?vue&type=template&id=099fb95e&scoped=true"
import script from "./CommonModel.vue?vue&type=script&lang=js"
export * from "./CommonModel.vue?vue&type=script&lang=js"
import style0 from "./CommonModel.vue?vue&type=style&index=0&id=099fb95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fb95e",
  null
  
)

export default component.exports